export default [
  {
    path: "/",
    name: "Dashboard",
    component: () => import("@/views/DashboardPage"),
    meta: { title: "nav.dashboard", requiresAuth: true },
  },
]
